import React from 'react';
import { useThemeContext } from '../../Context/ThemeContext';
import { useTheme } from 'next-themes';

export const CommonButton = ({
  text,
  onClick,
  size = "md",
  variant = "gradient",
  disabled,
  type = "button",
  color,
  className = "",
  width
}) => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];

  const sizeClasses = {
    sm: 'text-xs sm:text-sm px-2 sm:px-3 py-1',
    md: 'text-sm sm:text-base md:text-lg px-3 sm:px-4 md:px-5 py-2',
    lg: 'text-base sm:text-lg lg:text-xl px-4 sm:px-5 lg:px-6 py-3',
  };

  const baseClasses = `
    font-normal
    rounded-lg
    shadow-md
    transition
    duration-300
    flex
    items-center
    justify-center
    whitespace-normal
    break-words
    text-center
    max-w-full
    overflow-hidden
  `;

  const gradientClasses = `
    font-semibold
    shadow-[4px_4px_8px_rgba(0,0,0,0.3)]
    hover:opacity-90
  `;

  const defaultClasses = `
    text-gray-700
    hover:bg-gray-300
  `;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{ 
        color: color || theme.buttonPrimaryText,
        width,
        background: variant === 'gradient' ? theme.buttonPrimaryBg : theme.buttonDisabledBg,
        boxShadow: variant === 'gradient' ? theme.shadowButton : 'none'
      }}
      className={`
        ${sizeClasses[size]}
        ${baseClasses}
        ${variant === 'default' ? defaultClasses : gradientClasses}
        ${className}
      `}
    >
      {text}
    </button>
  );
};
